import { Select } from 'antd';
import { useCompaniesList } from '@/hooks/use-company/use-company';
import { useUser } from '@/hooks/use-user/use-user';
import { useEffect } from 'react';
import styles from './company-select-bh.module.scss';

export type SelectedCompany =
  | {
    id: number;
    name: string;
    time_zone: string;
  }
  | undefined;

type CompanySelectBhProps = {
  value: SelectedCompany;
  onChange: (value: SelectedCompany) => void;
};

export function CompanySelectBh({ value, onChange }: CompanySelectBhProps) {
  const { companies } = useCompaniesList();
  const { userData } = useUser();

  const companyOptions =
    companies?.map((company) => ({
      value: company.id,
      label: company.name,
    })) ?? [];

  useEffect(() => {
    if (!value && userData && companies && companies.length > 0) {
      const isCompanyAdmin = userData.roles?.some((role) => role.name === 'company_admin');

      if (isCompanyAdmin && userData.company) {
        const userCompany = companies.find((company) => company.id === userData.company?.id);

        if (userCompany) {
          onChange({
            id: userCompany.id,
            name: userCompany.name,
            time_zone: userCompany.time_zone,
          });
        }
      }
    }
  }, [value, userData, companies, onChange]);

  const handleChange = (id: number | undefined) => {
    if (!id) {
      onChange(undefined);
      return;
    }
    const company = companies?.find((company) => company.id === id);
    if (company) {
      onChange({ id: company.id, name: company.name, time_zone: company.time_zone });
    }
  };

  return (
    <Select
      className={styles.companySelect}
      options={companyOptions}
      value={value?.id}
      showSearch
      filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
      onChange={handleChange}
      placeholder="Select company"
      allowClear
      classNames={{
        popup: {
          root: styles.dropdown,
        },
      }}
    />
  );
}
